import { render, staticRenderFns } from "./SessionTimeout.vue?vue&type=template&id=aafd733c&"
import script from "./SessionTimeout.vue?vue&type=script&lang=js&"
export * from "./SessionTimeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aafd733c')) {
      api.createRecord('aafd733c', component.options)
    } else {
      api.reload('aafd733c', component.options)
    }
    module.hot.accept("./SessionTimeout.vue?vue&type=template&id=aafd733c&", function () {
      api.rerender('aafd733c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/SessionTimeout.vue"
export default component.exports